// extracted by mini-css-extract-plugin
export default {"products_disabled":"OrderDeliveryChunk_products_disabled__nha6f","divider":"OrderDeliveryChunk_divider__cRymE"};